import {createAxios} from '../index';

export const loginApiClient = createAxios({baseUrl: process.env.REACT_APP_LOGIN_API_URL});
